import createVueComponent from '../createVueComponent';

const Shield = createVueComponent('ShieldIcon', [
  ['path', { d: 'M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10', key: '1irkt0' }],
]);

export default Shield;
